<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Stock Delivery</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" text to="/stock/transfer/deliveries">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="6" xs="6" md="12">
            <v-btn color="accent" text @click="thermalPrint">
              <v-icon>mdi-printer</v-icon> Print Via Thermal
            </v-btn>

            <v-btn text @click="printDoc" color="primary" class="float-right">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> Generate
              Delivery
            </v-btn>
          </v-col>

          <v-col cols="6" xs="6" md="3"> </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary p-4">
          <v-col cols="12">
            <span>Doc No: {{ record.DocNum }}</span
            ><br />
            <span>Date: {{ record.DocDate }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <span>From: {{ record.fromstore && record.fromstore.Name }}</span
            ><br />
            <span
              >Picked By: {{ record.pickedby && record.pickedby.name }}</span
            >
          </v-col>

          <v-col cols="12" md="4">
            <span>To: {{ record.fromstore && record.fromstore.Name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              label="Search"
              outlined
              dense
            ></v-text-field>
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="stockTransfers"
              :search="search"
            >
              <template v-slot:item.BuyingPrice="{ item }">
                <span>{{ item.BuyingPrice.toLocaleString() }}</span>
              </template>
              <template v-slot:item.LineTotal="{ item }">
                <span>{{
                  (item.BuyingPrice * item.Quantity).toLocaleString()
                }}</span>
              </template>
              <template v-slot:item.received="{ item }">
                <span
                  style="color: green; font-weight: bold"
                  v-if="item.received == 'Y'"
                  >Received</span
                >
                <span
                  style="color: red; font-weight: bold"
                  v-if="item.received == 'N'"
                  >Not Received Yet</span
                >
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { generatePdf } from "@/common/transferMethods.js";
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      pageItems: 500,
      menu1: false,
      menu2: false,
      StartDate: null,
      EndDate: null,
      FromStore: null,
      ToStore: null,
      PickedBy: null,
      record: {},
      companyDetails: {},
      loader: false,
      stores: [],
      users: [],
      headers: [
        { text: "Item Code", value: "product.ItemCode" },
        { text: "Product", value: "product.Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Status", value: "received" },
        { text: "Ref No./ IMEI", value: "ref1" },
      ],
      stockTransfers: [],
    };
  },
  computed: {},
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    generatePdf,
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/single/stock/transfer/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
            self.stockTransfers = res.ResponseData.rows;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    thermalPrint() {
      const self = this;
      const storeId = this.ToStore;

      const store = this.stores.find((record) => {
        return record.id === storeId;
      });

      let storeName = "";

      if (store) {
        storeName = store.Name;
      }
      let details = {
        storeName: storeName,
        stock: self.stockTransfers,
        date: self.StartDate,
      };

      self.printLocalInventory(details);
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/StockTransfer.php",
        {
          stock,
        }
      );
    },
    printDoc() {
      const self = this;
      const pdfDoc = this.generatePdf(
        self.companyDetails,
        self.record,
        self.StartDate,
        self.EndDate,
        self.stockTransfers
      );

      this.$refs.pdfPreview.show(pdfDoc);
    },
    getCompanyDetails() {
      const self = this;
      this.$store
        .dispatch("get", `/company-details`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.companyDetails = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCompanyDetails();
  },
};
</script>

<style lang="scss" scoped>
</style>